import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Page, Footer } from '../common';
import versions from '../versions';

const Text = styled.div`
    width: 100%;
    max-Width: 1280px;
    margin: auto;
    padding: 1em;
    color: black;

    * > h2 {
        text-transform: uppercase;
    }
`;

const Terms = ({ app: { cms } }) => {
    return (
        <Page>
            <Page.Title>Ehdot ja säännöt</Page.Title>
            <Page.Content>
                <Text>
                    { cms && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cms.terms && cms.terms.content
                            }}
                        ></div>
                    )}
                    <p>Arpamaailma versio {versions.ui}</p>
                </Text>
                <Footer />
            </Page.Content>
        </Page>
    );
};

const mapStateToProps = (state) => {
    return {
        app: state.app
    };
};

const ConnectedTerms = connect(mapStateToProps)(Terms);

export { ConnectedTerms as Terms };
